import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import StarRateIcon from "@mui/icons-material/StarRate";
import google from "../../assets/images/google.png";
import theyellow from "../../assets/images/trypage.png";
import "./PatientReviews.css";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Navigation } from "swiper/modules";
import dblQuote from "../../assets/images/double-quotes (1).png";
import dblQuotelaptop from "../../assets/images/laptop.png";
import dblQuotemobile from "../../assets/images/mobile.png";
import healthgrade from "../../assets/images/healthg-removebg-preview.png";
import webmd from "../../assets/images/webmd-removebg-preview.png";
import wellness from "../../assets/images/wellness-removebg-preview.png";
import googleImg from "../../assets/images/google-removebg-preview.png";
import theyellowImg from "../../assets/images/yp-1-removebg-preview.png";
import Tilt from "react-parallax-tilt";
const PatientReviews = () => {
    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      }); // Scroll to the top when the component mounts
    }, []);
  const writeReview = [
    {
      id: 1,
      link: "https://www.healthgrades.com/group-directory/fl-florida/crystal-river",
      image: healthgrade,
    },
    {
      id: 2,
      link: "https://doctor.webmd.com/doctor/kamalesh-amin-9d9c5212-511c-4f60-91c6-60d3c9fd2417-overview",
      image: webmd,
    },
    {
      id: 3,
      link: "https://www.wellness.com/reviews/976490/citrus-diagnostic-center-radiologist?po=?catid=43",
      image: googleImg,
    },
    {
      id: 4,
      link: "http://google.com/maps/place/Citrus+Diagnostic+Center/@28.9035885,-82.5933738,15z/data=!4m7!3m6!1s0x0:0xeb4dead7dc4f5402!8m2!3d28.9035885!4d-82.5933738!9m1!1b1",
      image: wellness,
    },

    {
      id: 5,
      link: "https://www.yellowpages.com/crystal-river-fl/mip/citrus-diagnostic-center-9902913",
      image: theyellowImg,
    },
  ];
  const treatmentsTypes = [
    {
      id: 1,
      name: "William H.",
      image: google,
      description:
        "They were professional, polite, helpful and very understanding They were especially attentive to my special needs when getting my MRI from a power chair! 🙂",
    },
    {
      id: 2,
      name: "Roberta J.,",
      image: google,
      description:
        "Scheduling was quick and easy. They have appointments available right away which makes getting the test done sooner. They are great.",
    },
    {
      id: 3,
      name: "Maria N.,",
      image: theyellow,
      description:
        "Outstanding experience! While other facilities were telling me 3+ weeks to see me for my STAT order from my doctor Citrus Diagnostic saw me within 2 hours. A huge thank you to Felicia Jacobsen for getting me in so quickly! Very professional, friendly, caring staff and doctor! If I could give them more stars I would! I will definitely use this facility again!",
    },
    {
      id: 4,
      name: "Joanne S",
      image: google,
      description:
        "I have been to Citrus Diagnostic many times already and they have ALWAYS been very caring and professional! I know Jeff who works there… real nice guy!! Well I went on Fri 9/17 to actually make an appt but found out that one test was “stat” and Kasey who does the ultrasound took me about 4:30 and we didn’t finish until 6pm!! She stayed all that time not one complaint or moan from her! She was awesome! She made me very comfortable even when she couldn’t find my veins.. lol.. and was so gracious!! Thank you Kasey so much for everything!!",
    },
  ];
  return (
    <div className="pt-16 sm:pt-20 md:pt-24 lg:pt-[12.0625rem] text-white flex justify-center items-center flex-col  ">
      <div className="px-4 pb-8 pt-16 sm:px-6 sm:pt-10 md:px-8 md:pt-12 lg:px-10 flex xl:w-3/4 w-11/12  slider-wrapper overflow-hidden justify-center relative items-center flex-col lg:pt-16">
        <div className="text-center my-8 xl:mt-16 ">
          <h1 className="text-white font-Antique text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[9.25rem] lowercase tracking-[-.04em] leading-tight">
            Patient Reviews
          </h1>
        </div>
        <Swiper
          loop={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          grabCursor={true}
          spaceBetween={50}
          navigation={{
            nextEl: ".next-button",
            prevEl: ".prev-button",
          }}
          modules={[Navigation]}
          className="custom-swiper flex justify-center items-baseline mt-12 "
        >
          {treatmentsTypes.map((index) => (
            <SwiperSlide
              key={index}
              className="slide-card flex justify-center pt-16 relative "
            >
              <div className=" xl:w-4/5 2xl:w-3/4 w-full  ">
                <div className="flex flex-col justify-center lg:gap-2  gap-1 items-start overflow-y-auto 2xl:p-16 md:p-8 p-8">
                  <p className=" font-Matter -mt-2 2xl:text-[2.5rem] xl:text-4xl text-lg  2xl:leading-[1.2]">
                    {index.description}
                  </p>
                  <div className="flex md:justify-between justify-start md:flex-row flex-col w-full mt-8">
                    <div>
                      <h3 className="lg:text-3xl text-2xl capitalize  font-medium">
                        {index.name}
                      </h3>
                      <div className="mt-3">
                        <img src={`${index.image}`} className="w-36 " alt="" />
                      </div>
                    </div>
                    <div>
                      {" "}
                      <div className="mt-3">
                        <div className="mt-3 flex flex-row gap-2">
                          <span className="lg:text-4xl md:text-3xl text-2xl text-[#cfa751]">
                            <StarRateIcon fontSize="30px" />
                          </span>

                          <span className="lg:text-4xl md:text-3xl text-2xl text-[#cfa751]">
                            <StarRateIcon fontSize="30px" />
                          </span>

                          <span className="lg:text-4xl md:text-3xl text-2xl text-[#cfa751]">
                            <StarRateIcon fontSize="30px" />
                          </span>

                          <span className="lg:text-4xl md:text-3xl text-2xl text-[#cfa751]">
                            <StarRateIcon fontSize="30px" />
                          </span>

                          <span className="lg:text-4xl md:text-3xl text-2xl text-[#cfa751]">
                            <StarRateIcon fontSize="30px" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute xl:top-10 top-2 left-2">
                <img
                  src={dblQuote}
                  className="w-full hidden 2xl:block"
                  alt=""
                />
                <img
                  src={dblQuotelaptop}
                  className="w-28 hidden md:block 2xl:hidden "
                  alt=""
                />
                <img
                  src={dblQuotemobile}
                  className="w-28 block md:hidden "
                  alt=""
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="nav-container absolute w-full hidden  h-full md:flex justify-between items-center">
          <button className="group  nav-button prev-button relative inline-flex justify-center items-center h-16 w-14 mt-3 z-10  rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
            <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
              <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
              </span>
            </span>
            <span className="relative">
              <span className="block group-hover:opacity-0  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                <KeyboardBackspaceIcon />
              </span>
              <span className="absolute   top-0 left-0  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                <KeyboardBackspaceIcon />
              </span>
            </span>
          </button>
          <button className="group  nav-button next-button relative inline-flex justify-center items-center h-16 w-14 mt-3 z-10  rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
            <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
              <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
              </span>
            </span>
            <span className="relative">
              <span className="block group-hover:opacity-0 rotate-180  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                <KeyboardBackspaceIcon />
              </span>
              <span className="absolute   top-0 left-0  opacity-0 rotate-180 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                <KeyboardBackspaceIcon />
              </span>
            </span>
          </button>
        </div>
        <div className="nav-container  w-full flex  h-full  md:hidden justify-center items-center">
          <button className="group  nav-button prev-button relative inline-flex justify-center items-center h-16 w-14 mt-3 z-10  rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
            <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
              <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
              </span>
            </span>
            <span className="relative">
              <span className="block group-hover:opacity-0  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                <KeyboardBackspaceIcon />
              </span>
              <span className="absolute   top-0 left-0  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                <KeyboardBackspaceIcon />
              </span>
            </span>
          </button>
          <button className="group  nav-button next-button relative inline-flex justify-center items-center h-16 w-14 mt-3 z-10  rounded-full px-8 font-semibold text-black bg-transparent overflow-hidden">
            <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
              <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
              </span>
            </span>
            <span className="relative">
              <span className="block group-hover:opacity-0 rotate-180  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                <KeyboardBackspaceIcon />
              </span>
              <span className="absolute   top-0 left-0  opacity-0 rotate-180 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                <KeyboardBackspaceIcon />
              </span>
            </span>
          </button>
        </div>
      </div>
      <div className="mb-16 flex justify-center items-center flex-col">
        <h2 className="text-white font-Antique text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[9.25rem] lowercase tracking-[-.04em] leading-tight">
          Laeave a Review
        </h2>
        <div className=" mx-auto grid gap-8  grid-cols-1  justify-items-center sm:grid-cols-2 lg:grid-cols-3 mt-28 px-4">
          {writeReview.map((item, index) => (
            <Tilt key={index}>
              <div className="relative group mb-2">
                <div className="w-full p-4 rounded-3xl backdrop-blur-2xl bg-[#ffe7b2]  shadow-xl overflow-hidden">
                  <div className=" my-4 h-full flex items-center justify-center">
                    <img
                      src={`${item.image}`}
                      alt=""
                      className="w-full h-full object-cover rounded-2xl duration-500 "
                    />
                  </div>
                  <a
                    target="_blank"
                    rel="noreferrer noopener "
                    href={`${item.link}`}
                  >
                    <button
                      className="group relative bg-[#cfa751] h-16 w-full border-2 font-Matter border-yellow-300
                 text-white text-base tracking-wider font-bold rounded-3xl overflow-hidden transform transition-all duration-500
                  hover:scale-105 hover:border-white hover:text-black p-3 ps-6 text-left before:absolute
                   before:w-10 before:h-10 before:content[''] before:right-2 before:top-2 before:z-10 before:bg-[#3d0e26]
                    before:rounded-lg before:blur-lg before:transition-all before:duration-500 after:absolute after:z-10 
                    after:w-16 after:h-16 after:content[''] after:bg-[#8b5e3c] after:right-6 after:top-4 after:rounded-lg
                     after:blur-lg after:transition-all after:duration-500 hover:before:right-10 hover:before:-bottom-4 
                     hover:before:blur hover:after:-right-6 hover:after:scale-110"
                    >
                      Leave A Review
                    </button>
                  </a>
                </div>
              </div>
            </Tilt>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PatientReviews;
